import { Component } from '@felicity/vision';
import {
  IndicatorManager, IndicatorOptionManager, IndicatorStepManager
} from '@felicity/multi-criteria-analysis';
import { UnitOfMeasureSelector } from '@felicity/standards';

/**
 * Indicators screen
 */
export default class Indicators extends Component {
  /**
   * The languages supported by this screen
   * @type {string[]}
   */
  languages = [];

  /**
   * Provides access to the indicator manager
   * @type {IndicatorManager}
   */
  get indicatorManager() {
    return this.#manager;
  }

  /** @type {IndicatorManager} */
  #manager;

  constructor() {
    super();

    this.#manager = new IndicatorManager();
  }

  _prepare() {
    super._prepare();
    this.classList.add('screen');

    this.indicatorManager.languages = this.languages;
    this.indicatorManager.crudUri = '/api/Indicators/Indicator';
    this.indicatorManager.configManagerCrudUri = '/api/Indicators/IndicatorConfig';

    this.appendChild(this.indicatorManager);
    this.indicatorManager.grid.height = '100%';
    this.indicatorManager.grid.width = '100%';
  }
}

IndicatorOptionManager.register('indicator-option-manager');
IndicatorStepManager.register('indicator-step-manager');
IndicatorManager.register('indicator-manager');
UnitOfMeasureSelector.register('unit-of-measure-selector');
